/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, OnInit, Renderer2} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {I18nService, NO_USER} from '../../_services/i18n.service';
import {ToolsHelper} from '../../_helpers/tools-helper';
import {PRE_CONDITION_FAILED} from '../../_enums/requests';


@Component({
  selector: 'app-boviclic-error',
  templateUrl: './boviclic-error.component.html',
  styleUrls: ['./boviclic-error.component.scss']
})
export class BoviclicErrorComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PROPERTIES                                                                                            ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public showContact: boolean;

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(private activatedRoute: ActivatedRoute, private i18n: I18nService, private renderer: Renderer2) {
    this.renderer.setStyle(document.body, 'background-color', 'rgba(117, 54, 230, .1)');
    this.showContact = false;
  }

  ngOnInit() {
    // This is intentional
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              VALUES GETTERS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  get errorCode(): number | null {
    let code = null;

    if (this.activatedRoute.snapshot.queryParams.code) {
      code = Number(this.activatedRoute.snapshot.queryParams.code);
    } else if (this.activatedRoute.snapshot.params.code) {
      code = Number(this.activatedRoute.snapshot.params.code);
    }

    return ToolsHelper.isNumber(code) ? code : null;
  }

  get message(): string | null {
    this.showContact = false;

    if (PRE_CONDITION_FAILED === this.errorCode) {
      this.showContact = true;
      return this.i18n.get(NO_USER);
    }

    return this.i18n.get(this.errorCode);
  }

}
